module.exports = __webpack_public_path__ + "img/logo-barrionuevo.c42de98b.png";